import type { ReactNode } from 'react'

import { s3URL } from '@mathflat/common/index'

import type { NavInfoList } from '@/component/organisms/Navigation/SideNavigation/SideNavigation'
import type { RoutePermissionType } from '@/models/(Permission)/RoutePermission.type'
import { RouteName } from '@/router/RouteName'
import { Icon } from '@design-system/index'
import { css } from '@emotion/react'
import { Badge } from '@/component/atoms/Badge'

export type ProfileNavActions = {
  mathflatConnect?: () => void
}

type ProfileNavItem =
  | {
      label?: string
      labelContent?: ReactNode
      action?: () => void
      to?: string
      isNew?: boolean
      showInSidebar?: boolean
      disabled?: boolean
    }
  | false
  | undefined

export type ProfileNavInfoList = {
  title?: string
  items: ProfileNavItem[]
}[]

type SideNavCompatibleItem = { label: string; to: string; isNew?: boolean }

export const toSideNavInfoList = (list: ProfileNavInfoList): NavInfoList =>
  list.map((group) => ({
    ...group,
    items: group.items.filter(
      (item): item is SideNavCompatibleItem =>
        !!item && item.showInSidebar !== false && !!item.label && !!item.to,
    ),
  }))

export const getMyPageNavigation = (
  permission: RoutePermissionType,
  actions?: ProfileNavActions,
): ProfileNavInfoList => {
  const navInfoList: ProfileNavInfoList = [
    {
      items: [
        permission.myinfo.access && {
          labelContent: (
            <div
              css={css`
                display: flex;
                align-items: center;
                gap: 4px;
              `}
            >
              <img
                src={s3URL.mathflatAssetsBucket.scienceflat('mathflat_logo.svg')}
                width={68}
                alt="매쓰플랫"
              />
              <Icon name="share" size={16} color="var(--Colors-Blue-500)" />
            </div>
          ),
          action: actions?.mathflatConnect,
          showInSidebar: false,
        },
        permission.myinfo.access && {
          labelContent: (
            <div
              css={css`
                display: flex;
                align-items: center;
                gap: 4px;
                opacity: 0.5;
              `}
            >
              <img
                src={s3URL.mathflatAssetsBucket.teacher('images/logos/englishflat_logo.svg')}
                width={90}
                alt="잉글리시플랫"
              />
              <Badge backgroundColor="var(--Colors-Indigo-500)" size="xs" radius="100">
                Coming Soon
              </Badge>
            </div>
          ),
          showInSidebar: false,
          disabled: true,
        },
        permission.myinfo.기관정보.access && {
          label: '내 정보',
          to: RouteName.myUserInfo,
        },
      ],
    },
    {
      title: '고객지원',
      items: [
        permission.고객지원.access && {
          label: '공지 및 업데이트',
          to: RouteName.customerNotice,
        },
        // permission.고객지원.access && {
        //   label: '1:1 문의',
        //   to: RouteName.customerQna,
        // },
        // permission.고객지원.access && {
        //   label: '자주 묻는 질문',
        //   to: RouteName.customerFaq,
        // },
        permission.myinfo.사용가이드.access && {
          label: '사용 가이드',
          to: RouteName.guide,
        },
      ],
    },
  ]

  return navInfoList
}
